import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DateSelector.css';
import { format, formatDate } from 'date-fns';

const DateSelector = ({ onDateChange, save }) => {
    const now = new Date();
    const [startDate, setStartDate] = useState(new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30));
    const [startDate_Apply, setStartDate_Apply] = useState(new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30));
    const [endDate, setEndDate] = useState(now);
    const [endDate_Apply, setEndDate_Apply] = useState(now);
    const [selectedOption, setSelectedOption] = useState('30 ngày gần đây');
    const [selectedOption_Apply, setSelectedOption_Apply] = useState('30 ngày gần đây');

    const options = ['7 ngày gần đây', '30 ngày gần đây', 'Tháng này', "90 ngày gần đây"];

    const handleSelectChange = (option) => {
        setSelectedOption(option);
        switch (option) {
            case '7 ngày gần đây':
                setStartDate(new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7));
                setEndDate(now);
                break;
            case '30 ngày gần đây':
                setStartDate(new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30));
                setEndDate(now);
                break;
            case '90 ngày gần đây':
                setStartDate(new Date(now.getFullYear(), now.getMonth(), now.getDate() - 90));
                setEndDate(now);
                break;
            case 'Tháng này':
                setStartDate(new Date(now.getFullYear(), now.getMonth(), 1));
                setEndDate(now);
                break;
            default:
                break;
        }
    };
    useEffect(() => {
        // console.log(endDate.split('/').reverse().join('-'))
        // console.log(formatDate(endDate, 'yyyy-MM-dd'));
        onDateChange(getDays());
    }, [startDate_Apply, endDate_Apply, selectedOption_Apply]);
    const getDays = () => {
        return { "startDate": startDate_Apply, "endDate": endDate_Apply, selectedOption };
    };

    const changePickDate = (event) => {
        try {
            const value = event.target.value;
            const date = value.split('-');
            if (date.length < 3) return;
            // console.log(date);
            if (event.target.id == "startDate") {
                setStartDate(new Date(date[0], date[1] - 1, date[2]));
                setSelectedOption(`${format(value, 'dd/MM/yyyy')} - ${format(endDate, 'dd/MM/yyyy')}`);
            } else {
                setEndDate(new Date(date[0], date[1] - 1, date[2]));
                setSelectedOption(`${format(startDate, 'dd/MM/yyyy')} - ${format(value, 'dd/MM/yyyy')}`);
            }
        } catch (e) { }

    }

    const onClickApply = () => {
        setStartDate_Apply(startDate);
        setEndDate_Apply(endDate);
        setSelectedOption_Apply(selectedOption);
        save();
    }

    return (
        <div>
            <div className="position-absolute shadow px-4 pt-4 w-auto bg-white rounded-lg pb-4 mt-0" style={{ zIndex: "2" }}>
                <div>
                    <div className="form-group mb-3">
                        <div className="d-flex justify-content-between align-items-start">
                            <label htmlFor="chooseRange" className="font-weight-bolder">Chọn khoảng thời gian</label></div>
                        <div className="KeenSelectOption">
                            <div className="w-100">
                                <div className="dropdown">
                                    <button type="button" id="chooseRange" data-bs-toggle="dropdown" aria-expanded="false" className="w-100 cursor-pointer border shadow-none d-flex align-items-center justify-content-between rounded-4 dropdown-toggle btn">
                                        {selectedOption}
                                    </button>
                                    <ul className="dropdown-menu w-100" aria-labelledby="chooseRange">
                                        {
                                            options.map((option, index) => (
                                                <span key={index} className={`dropdown-item border-bottom ${selectedOption == option ? "text-primary" : ""}`}
                                                    style={{ borderTop: "1px", display: "flex", justifyContent: "space-between" }}
                                                    onClick={() => handleSelectChange(option)}
                                                >
                                                    <span>
                                                        {option}
                                                    </span>
                                                    {
                                                        selectedOption == option &&
                                                        <div className="d-flex align-items-center justify-content-end">
                                                            <i className="fa fa-check text-primary" style={{ fontSize: '10px' }}></i>
                                                        </div>
                                                    }

                                                </span>
                                            ))
                                        }
                                    </ul>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center gap-3">
                        <div className="form-group mb-0">
                            <div className="d-flex justify-content-between align-items-start">
                                <label htmlFor="startDate" className="font-weight-bolder">Ngày bắt đầu</label>
                            </div>
                            <div className="w-100">
                                <div>
                                    <input className="form-control" type="date" name="startDate" id="startDate"
                                        placeholder="dd/MM/YYYY" maxLength="" data-toggle="" autoComplete="off" step="1"
                                        value={formatDate(startDate, 'yyyy-MM-dd')}
                                        onChange={changePickDate} />
                                </div>
                            </div>
                        </div>
                        <div className="form-group mb-0">
                            <div className="d-flex justify-content-between align-items-start">
                                <label htmlFor="endDate" className="font-weight-bolder">Ngày kết thúc</label>
                            </div>
                            <div className="w-100">
                                <div>
                                    <input className="form-control" type="date" name="endDate" id="endDate" placeholder="Ngày kết thúc..." maxLength="" data-toggle="" autoComplete="off" step="1"
                                        value={formatDate(endDate, 'yyyy-MM-dd')}
                                        onChange={changePickDate} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                    <button className="d-flex flex-row align-items-center justify-content-center btn btn-info" type=""
                        style={{ whiteSpace: "nowrap", fontSize: "1rem", fontWeight: "600", padding: "8px" }}
                        onClick={() => onClickApply()}
                    >
                        <span className="mx-2 d-flex h-100 align-items-center">Lưu lại</span>
                    </button>
                </div>
            </div>
        </div>
    );

};

export default DateSelector;